module.exports = __webpack_public_path__ + "media/logos/logo-a44354c8.png";